import { useEffect, useState } from 'react'
import SurfaceObsAPI from './SurfaceObsAPI'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMETARData } from './METAR/METARAPI'
import { fetchTAFData } from './TAF/TAFAPI'
import fetchAIRMETData from './AIRMET/AIRMETAPI'
import getActiveEvents, {
  getActiveEventsAuto,
} from '../Components/Alerting/AlertingSlice/getActiveAlerts'
import {
  hideAlertSETTING,
  setAlertingNotification,
  showAlertSETTINGCreate,
  showEventList,
  showEventsIfAlertNotPresent,
  sideNavRefresh,
  setEventCount,
} from '../Components/Alerting/AlertingSlice/AlertingSlice'
import fetchSIGMETData from './SIGMET/SIGMETAPI'
import fetchPIREPData from './PIREP/PIREPAPI'
import { RootState } from '../store'
import NetworkData from '../interfaces/networkData'
import { getAllEvents } from '../menus/SlideOverDialog/SlideOverDialogEvents'
import { EventParser } from '../utils/ALERTUtils'
import { getUniqueSensorTypes } from '../utils/SurfaceObsUtils'
import { useSlideOverDialogContext } from '../menus/SlideOverDialog/SlideOverDialogContext'
import useErrorStatus from '../hooks/UseErrorStatus'
import {
  deselectMenuItemById,
  setSelectedItemIds,
  setSelectedItems,
} from '../menus/SideNavigation/SideNavigationSlice'
import useAlertSetting from '../Components/Alerting/useAlertSetting'
import { pollingIntervals } from '../services/RequestTimeouts'
import { MenuLabels } from '../constants/MenuLabels'
import { useInterval } from '../hooks/useInterval'
import useTWSMapContext from '../hooks/UseTWSContext'

const NetworkAdapter = ({ selectedSideNav, setnetworkData }) => {
  const dispatch = useDispatch()
  const { addAlertSideNav } = useAlertSetting()
  const defaultLocation = useSelector((state) => state.user.defaultLocation)
  const alertNotification = useSelector(
    (state) => state.alert.callNetworkAdapter
  )
  const selectedItems = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const finalEventsToDisplay = useSelector(
    (state) => state.alert.finalEventsToDisplay
  )

  const [userClickedAlertBtn, setUserClickedAlertBtn] = useState(true)

  const [surfaceObsData, setSurfaceObsData] = useState<NetworkData[]>([])
  const [metarData, setMetarData] = useState<NetworkData[]>([])
  const [tafData, setTafData] = useState<NetworkData[]>([])
  const [airmetData, setAirmetData] = useState<NetworkData[]>([])
  const [alertData, setAlertData] = useState<NetworkData[]>([])
  const [sigmetData, setSigmetData] = useState<NetworkData[]>([])
  const [pirepData, setPirepData] = useState<NetworkData[]>([])
  const [eventsData, setEventsData] = useState<NetworkData[]>([])
  const [eventsbeforeAlertData, seteventsbeforeAlertData] = useState<
    NetworkData[]
  >([])

  const errorStatusHook = useErrorStatus()
  const {
    airmetRefresh,
    sigmetRefresh,
    metarRefresh,
    tafRefresh,
    pirepRefresh,
    alertRefresh,
    surfaceObsRefresh,
  } = pollingIntervals // intervals stored in RequestTimeouts.ts
  const { setTotalProducts } = useSlideOverDialogContext()
  const { removeFromTWS } = useTWSMapContext()

  //intervals
  const [surfaceObsInterval, setSurfaceObsInterval] =
    useState<number>(surfaceObsRefresh)
  const [metarInterval, setMetarInterval] = useState<number>(metarRefresh)
  const [tafInterval, setTafInterval] = useState<number>(tafRefresh)
  const [pirepInterval, setPirepInterval] = useState<number>(pirepRefresh)
  const [sigmetInterval, setSigmetInterval] = useState<number>(sigmetRefresh)
  const [airmetInterval, setAirmetInterval] = useState<number>(airmetRefresh)

  useEffect(() => {
    setSurfaceObsData([])
    setMetarData([])
    setTafData([])
    setAirmetData([])
    setAlertData([])
    setSigmetData([])
    setPirepData([])
    setnetworkData([])
  }, [defaultLocation])


  useEffect(() => {
    if (!selectedItems.includes(MenuLabels.PIREPS)) {
      setPirepData([])
    }
    if (!selectedItems.includes(MenuLabels.TAFS)) {
      setTafData([])
    }
    if (!selectedItems.includes(MenuLabels.GAIRMETS)) {
      setAirmetData([])
    }
    if (!selectedItems.includes(MenuLabels.SIGMETS)) {
      setSigmetData([])
    }
    if (!selectedItems.includes(MenuLabels.METARS)) {
      setMetarData([])
    }
    if (!selectedItems.includes(MenuLabels.SURFACEOBS)) {
      setSurfaceObsData([])
    }
  }, [selectedItems])

  useEffect(() => {
    const intervalId = setInterval(() => {
      setAlertData([])
    }, 60000)
    return () => clearInterval(intervalId)
  }, [])
  // useEffect(()=>{
  //   if(selectedItems.includes("MissionCast")){
  //     dispatch(toggleMissionCast(true))
  //   }
  //   else{
  //     dispatch(toggleMissionCast(false))
  //   }
  // },
  // [selectedItems])
  useEffect(() => {
    setnetworkData([
      ...surfaceObsData,
      ...metarData,
      ...tafData,
      ...airmetData,
      ...alertData,
      ...sigmetData,
      ...pirepData,
      ...eventsData,
      ...eventsbeforeAlertData,
    ])
  }, [alertData])
  useEffect(() => {
    // let surfaceData = []
    const fetchNetworkData = async () => {
      if (
        surfaceObsData.length == 0 &&
        selectedItems.includes(MenuLabels.SURFACEOBS)
      ) {
        refreshSurfaceObsData()
      }

      if (metarData.length == 0 && selectedItems.includes(MenuLabels.METARS)) {
        refreshMetarData()
      }

      if (tafData.length == 0 && selectedItems.includes(MenuLabels.TAFS)) {
        refreshTafData()
      }

      if (
        airmetData.length == 0 &&
        selectedItems.includes(MenuLabels.GAIRMETS)
      ) {
        refreshAirmetData()
      }

      if (
        sigmetData.length == 0 &&
        selectedItems.includes(MenuLabels.SIGMETS)
      ) {
        refreshSigmetData()
      }

      if (pirepData.length == 0 && selectedItems.includes(MenuLabels.PIREPS)) {
        refreshPirepData()
      }

      if (
        alertData.length == 0 &&
        selectedItems.includes(MenuLabels.ALERTS_MENU)
      ) {
        dispatch(sideNavRefresh())
        var updatedItemIds = []
        for (const itemID of selectedItems) {
          if (
            itemID == 'alerts-create' ||
            itemID == 'alerts-menu' ||
            !itemID.startsWith('alerts')
          ) {
            updatedItemIds.push(itemID)
          }
        }
        dispatch(setSelectedItemIds(updatedItemIds))
        const updates = []
        const val = Object.values(finalEventsToDisplay)
        if (val?.length > 0) {
          const valuesArray = [...val]
          const parsedData = EventParser(valuesArray)
          seteventsbeforeAlertData(parsedData)
          updates.push(parsedData)
        }
        // setnetworkData((prevState) => (prevState !== null ? [...prevState, ...updates.flat()] : updates.flat()));
        var hazardType_label_map = {
          TEMPERATURE: 'Temperature',
          WINDS_80M: '250FT Wind Speed',
          WINDS_RTMA: 'Surface Wind Speed',
          VISIBILITY: 'Visibility',
          WINDGUSTS_RTMA: 'Surface Wind Gust',
          CEILINGS: 'Ceiling',
          MRMS_PRECIP: 'Precipitation',
          LIGHTNING_ALERT: 'Lightning',
          TOR_WARNING_NWS: 'NWS Alerts',
          SVR_WARNING_NWS: 'NWS Alerts',
        }

        var hazardType_id_map = {
          TEMPERATURE: 'alerts-temperature',
          WINDS_80M: 'alerts-wind-speed',
          WINDS_RTMA: 'alerts-surface-winds',
          VISIBILITY: 'alerts-visibility',
          WINDGUSTS_RTMA: 'alerts-wind-gust',
          CEILINGS: 'alerts-ceiling',
          MRMS_PRECIP: 'alerts-precipitation',
          LIGHTNING_ALERT: 'alerts-lightning',
          TOR_WARNING_NWS: 'alerts-nws',
          SVR_WARNING_NWS: 'alerts-nws',
        }
        const uniqueHazard = new Set()

        /**
         *
         * We poll GET /alerts every 60 seconds and we want to be able to filter
         * this polling call from user click.
         *
         * For this reason we are calling a different API when polling.
         *
         * Initially userClickedAlertBtn is true. When its true, we call the api and make it false
         *
         * When we poll, this will be false and we'll call the polling API.
         *
         * This is still very hacky way of doing things and I would prefer using web sockets over polling.
         */
        let alertPromise

        if (userClickedAlertBtn) {
          alertPromise = getActiveEvents()
          setUserClickedAlertBtn(false)
        } else {
          alertPromise = getActiveEventsAuto()
        }

        alertPromise
          .then((eventData) => {
            const [alertData, eventCount] = eventData
            dispatch(setAlertingNotification(eventData))
            dispatch(setEventCount(eventCount))
            // for (const alert of alertData) {
            //   uniqueHazard.add(alert['properties']['hazardType'])
            // }
            // for (const hazardType of uniqueHazard) {
            //   addAlertSideNav(hazardType_label_map[hazardType])
            //   dispatch(setSelectedItemIds(hazardType_id_map[hazardType]))
            // }
            if (alertData?.length > 0) {
              setAlertData(alertData)
              updates.push(alertData)
            }
          })
          .catch((err) => {
            errorStatusHook.addMessage(
              "Alerting can't be accessed. Please check your subscription and try again.",
              400,
              'error',
              false
            )
          })
      } else if (
        (alertData.length != 0 || eventsbeforeAlertData != 0) &&
        !alertNotification &&
        !selectedItems.includes(MenuLabels.ALERTS_MENU)
      ) {
        //dispatch(hideAlertSETTING())
        //dispatch(showAlertSETTINGCreate(false))
        dispatch(sideNavRefresh())
        dispatch(showEventsIfAlertNotPresent(false))
        dispatch(showEventList(false))
        if (selectedItems.includes(MenuLabels.EVENT_LIST)) {
          let tempSelectedItems = [...selectedItems]
          tempSelectedItems = tempSelectedItems.filter(
            (item) => item !== MenuLabels.EVENT_LIST
          )
          dispatch(setSelectedItems(tempSelectedItems))
        }
        setAlertData([])
        seteventsbeforeAlertData([])
      }
      // To Add Other API calls for Map Markers with Table Popup Add Here
      // Keep Data type in format interface NetworkData
      if (
        eventsData.length == 0 &&
        selectedItems.includes(MenuLabels.EVENT_LIST)
      ) {
        dispatch(showEventsIfAlertNotPresent(false))
        seteventsbeforeAlertData([])
        dispatch(showEventList(true))
        const tempeventsData = await getAllEvents()
        const parsedData = EventParser(tempeventsData)
        if (tempeventsData?.length > 0) {
          setEventsData(parsedData)
        }
      } else if (
        eventsData.length != 0 &&
        !selectedItems.includes(MenuLabels.EVENT_LIST)
      ) {
        dispatch(showEventList(false))
        setEventsData([])
      }

      if (
        !selectedItems.includes('Alerts') &&
        !selectedItems.includes('Alertss') &&
        !userClickedAlertBtn
      ) {
        setUserClickedAlertBtn(true)
      }

      // const l = surfaceData.length != 0 ? surfaceData : surfaceObsData
      // setnetworkData([
      //   ...l,
      //   ...metarData,
      //   ...tafData,
      //   ...airmetData,
      //   ...alertData,
      //   ...sigmetData,
      //   ...pirepData,
      //   ...eventsData,
      //   ...eventsbeforeAlertData,
      // ])
    }
    fetchNetworkData()
  }, [selectedItems])

  useEffect(() => {
    setnetworkData([
      ...surfaceObsData,
      ...metarData,
      ...tafData,
      ...airmetData,
      ...alertData,
      ...sigmetData,
      ...pirepData,
      ...eventsData,
      ...eventsbeforeAlertData,
    ])
  }, [
    surfaceObsData,
    metarData,
    tafData,
    airmetData,
    alertData,
    sigmetData,
    pirepData,
    eventsData,
    eventsbeforeAlertData,
  ])

  const refreshSurfaceObsData = () => {
    SurfaceObsAPI(defaultLocation)
      .then((data) => {
        setSurfaceObsData(data)
        setTotalProducts(getUniqueSensorTypes(data))
        if (!data.length) {
          removeFromTWS(MenuLabels.SURFACEOBS)
          errorStatusHook.addMessage(
            'No sensors available at this location',
            400,
            'error',
            false
          )
          dispatch(deselectMenuItemById(MenuLabels.SURFACEOBS))
        }
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (surfaceObsRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
      })
  }

  const refreshMetarData = () => {
    fetchMETARData(defaultLocation)
      .then((data) => {
        setMetarData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (metarRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.METARS))
      })
  }

  const refreshTafData = () => {
    fetchTAFData(defaultLocation)
      .then((data) => {
        setTafData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (tafRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.TAFS))
      })
  }

  const refreshPirepData = () => {
    fetchPIREPData(defaultLocation)
      .then((data) => {
        setPirepData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (pirepRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.PIREPS))
      })
  }

  const refreshAirmetData = () => {
    fetchAIRMETData(defaultLocation)
      .then((data) => {
        setAirmetData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            '. Will retry in ' +
            (airmetRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.GAIRMETS))
      })
  }

  const refreshSigmetData = () => {
    fetchSIGMETData(defaultLocation)
      .then((data) => {
        setSigmetData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (sigmetInterval / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById('aviation-sigmet'))
      })
  }

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.SURFACEOBS)) {
      refreshSurfaceObsData()
    }
  }, surfaceObsInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.METARS)) {
      refreshMetarData()
    }
  }, metarInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.TAFS)) {
      refreshTafData()
    }
  }, tafInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.PIREPS)) {
      refreshPirepData()
    }
  }, pirepInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.GAIRMETS)) {
      refreshAirmetData()
    }
  }, airmetInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.SIGMETS)) {
      refreshSigmetData()
    }
  }, sigmetInterval)
}

export default NetworkAdapter
